<script>
import Layout from "../../layouts/auth";
import { authMethods, authFackMethods, notificationMethods } from "@/state/helpers";
import { mapState } from "vuex";

import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";

import { getUser } from '@/api/user'
import { mymylogin } from '@/api/user'


/**
 * Login component
 */
export default {
  page: {
    title: "Login",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      email: "",
      password: "",
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
      loginInfo: {},
      user: {}
    };
  },
  validations: {
    email: {
      required,
    },
    password: {
      required,
    },
  },
  computed: {
    ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.submitted = true;

      console.log('submitt!')
      // stop here if form is invalid
      // this.$v.$touch();

      this.loginInfo['username'] = this.email
      this.loginInfo['password'] = this.password
      const fd = new FormData()
      fd.append("username", this.email)
      fd.append("password", this.password)
      console.log(fd)
      mymylogin(fd).then(res => {
         console.log('login res: ', res)
         //this.user['userName'] = res['data']['userName']
         //this.user['userId'] = res['data']['userId']
         //localStorage.setItem('user', JSON.stringify(this.user));
         //localStorage.setItem('exchangeName', 'huobi');
         var user_info = res[0]
         var  menu = JSON.stringify(res[1])
         var default_url = res[1][1]["subItems"][0]["link"]
         var default_alias = default_url.split("=")[1]
         let auth_links = JSON.stringify(res[2])
         console.log(default_url)
         localStorage.setItem("auth_link", auth_links)
         localStorage.setItem("backend_version", user_info["backend_version"])
         localStorage.setItem('token', user_info["access_token"]);
         localStorage.setItem('token_type', user_info["token_type"]);
         localStorage.setItem('is_admin', user_info["is_super"]);
         localStorage.setItem('username', user_info["username"]);
         localStorage.setItem('menu_config', menu);
         localStorage.setItem('default_alias', default_alias);
         localStorage.setItem('default_url', default_url);
         this.$router.push(default_url)
        //  this.$router.push("/")
         

       }).catch(error => {
         console.log('login error: ', error)
       })


      // getUser().then(response => {
      //   console.log(response)
      //   this.$router.push("/")
      // }).catch(error => {
      //   console.log(error)
      // })

      // if (this.$v.$invalid) {
      //   return;
      // } else {
      //   if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
      //     this.tryingToLogIn = true;
      //     // Reset the authError if it existed.
      //     this.authError = null;
      //     return (
      //       this.logIn({
      //         email: this.email,
      //         password: this.password,
      //       })
      //         // eslint-disable-next-line no-unused-vars
      //         .then((token) => {
      //           this.tryingToLogIn = false;
      //           this.isAuthError = false;
      //           // Redirect to the originally requested page, or to the home page
      //           this.$router.push(
      //             this.$route.query.redirectFrom || {
      //               name: "default",
      //             }
      //           );
      //         })
      //         .catch((error) => {
      //           this.tryingToLogIn = false;
      //           this.authError = error ? error : "";
      //           this.isAuthError = true;
      //         })
      //     );
      //   } else if (process.env.VUE_APP_DEFAULT_AUTH === "fakebackend") {
      //     const { email, password } = this;
      //     if (email && password) {
      //       this.login({
      //         email,
      //         password,
      //       });
      //     }
      //   } else if (process.env.VUE_APP_DEFAULT_AUTH === "authapi") {
      //     axios
      //       .post("http://127.0.0.1:8000/api/login", {
      //         email: this.email,
      //         password: this.password,
      //       })
      //       .then((res) => {
      //         return res;
      //       });
      //   }
      // }
    },
  },
  mounted() {},
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div>
            <div class="row">
              <div class="col-3">
              </div>
              <div class="col-6">
                <!-- <img
                  src="@/assets/images/profile-img.png"
                  alt
                  class="img-fluid"
                > -->

                <img
                  src="@/assets/images/zenx_logo/logo1.png"
                  alt
                  class="img-fluid"        
                >
              </div>
              <div class="col-7">
                <div class="text-primary p-4">
                  <!-- <h3 class="text-primary">
                    Zenx
                  </h3> -->
                  <p style="color:#F2F5F7;font-size:20px;width: 190%;height: 2px;display: block;line-height: 2px;text-align: center;"> Crypto Management Portal</p>
                </div>
              </div>
              <div class="col-3">
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
              <!-- <div>
                <router-link
                  tag="a"
                  to="/"
                >
                  <div class="avatar-md profile-user-wid mb-4">
                    <span class="avatar-title rounded-circle bg-light">
                      <img
                        src="@/assets/images/zenx_logo/ZenX2-01.png"
                        alt
                        height="70"
                      >
                    </span>
                  </div>
                </router-link>
              </div> -->
            <b-alert
              v-model="isAuthError"
              variant="danger"
              class="mt-3"
              dismissible
            >
              {{ authError }}
            </b-alert>

            <div
              v-if="notification.message"
              :class="'alert ' + notification.type"
            >
              {{ notification.message }}
            </div>

            <b-form
              class="p-2"
              @submit.prevent="tryToLogIn"
            >
              <b-form-group
                id="input-group-1"
                label="用户名"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="email"
                  type="text"
                  placeholder="输入用户名"
                  :class="{ 'is-invalid': submitted && $v.email.$error }"
                />
                <div
                  v-if="submitted && $v.email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.email.required">请输入用户名</span>
                  <span v-if="!$v.email.email">请输入合法的用户名</span>
                </div>
              </b-form-group>

              <b-form-group
                id="input-group-2"
                label="密码"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="password"
                  type="password"
                  placeholder="输入密码"
                  :class="{ 'is-invalid': submitted && $v.password.$error }"
                />
                <div
                  v-if="submitted && !$v.password.required"
                  class="invalid-feedback"
                >
                  请输入密码
                </div>
              </b-form-group>
              <div class="custom-control custom-checkbox">
                <input
                  id="customControlInline"
                  type="checkbox"
                  class="custom-control-input"
                >
                <label
                  class="custom-control-label"
                  for="customControlInline"
                >记住我</label>
              </div>
              <div class="mt-3">
                <b-button
                  type="submit"
                  variant="primary"
                  class="btn-block"
                >
                  登录
                </b-button>
              </div>
              <div class="mt-4 text-center">
                <!-- <router-link
                  tag="a"
                  to="/forgot-password"
                  class="text-muted"
                >
                  <i class="mdi mdi-lock mr-1" /> 忘记密码?
                </router-link> -->
              </div>
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <!-- <p>
            没有账号 ?
            <router-link
              tag="a"
              to="/register"
              class="font-weight-medium text-primary"
            >
              注册
            </router-link>
          </p> -->
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
